import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "exam-time"
};
const _hoisted_2 = {
  key: 1,
  class: "paper-context"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_step = _resolveComponent("el-step");
  const _component_el_steps = _resolveComponent("el-steps");
  const _component_el_button = _resolveComponent("el-button");
  const _component_mm_drag = _resolveComponent("mm_drag");
  const _component_mm_mcq = _resolveComponent("mm_mcq");
  const _component_writing = _resolveComponent("writing");
  const _component_proofreading = _resolveComponent("proofreading");
  const _component_mm = _resolveComponent("mm");
  const _component_MenuBox = _resolveComponent("MenuBox");
  const _component_SelfEvaluation = _resolveComponent("SelfEvaluation");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_steps, {
    active: $setup.step,
    simple: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_step, {
      title: "1 写前自评",
      icon: $setup.List
    }, null, 8, ["icon"]), _createVNode(_component_el_step, {
      title: "2 间接写作",
      icon: $setup.EditPen
    }, null, 8, ["icon"]), _createVNode(_component_el_step, {
      title: "3 直接写作",
      icon: $setup.EditPen
    }, null, 8, ["icon"]), _createVNode(_component_el_step, {
      title: "4 写后自评1",
      icon: $setup.List
    }, null, 8, ["icon"]), _createVNode(_component_el_step, {
      title: "5 写后自评2",
      icon: $setup.List
    }, null, 8, ["icon"])]),
    _: 1
  }, 8, ["active"]), $setup.paperInfo.items && ($setup.step == 1 || $setup.step == 2) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "margin-right": "5px",
      "font-size": "20px"
    },
    icon: $setup.Timer,
    size: "large"
  }, null, 8, ["icon"]), _createElementVNode("p", null, [_cache[4] || (_cache[4] = _createTextVNode(" 考试时间", -1)), _createElementVNode("span", null, _toDisplayString($setup.timeText), 1)]), _withDirectives(_createVNode(_component_el_button, {
    color: "#1d5595",
    type: "success",
    size: "large",
    onClick: _cache[0] || (_cache[0] = $event => $setup.finishExam(1))
  }, {
    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("交 卷", -1)]))]),
    _: 1
  }, 512), [[_vShow, $props.examInfo.subdivide == 3]])])) : _createCommentVNode("", true), $setup.paperInfo.items && ($setup.step == 1 || $setup.step == 2) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-drag' ? (_openBlock(), _createBlock(_component_mm_drag, {
    key: 0,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-mcq' ? (_openBlock(), _createBlock(_component_mm_mcq, {
    key: 1,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'writing' ? (_openBlock(), _createBlock(_component_writing, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer,
    onSave: _cache[1] || (_cache[1] = $event => $setup.setcache())
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'proofreading' ? (_openBlock(), _createBlock(_component_proofreading, {
    key: 3,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[_ctx.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm' ? (_openBlock(), _createBlock(_component_mm, {
    key: 4,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.paperInfo.items && $setup.step == 1 ? (_openBlock(), _createBlock(_component_MenuBox, {
    key: 2,
    examType: $props.examInfo.subdivide,
    paperInfo: $setup.paperInfo,
    itemNo: $setup.itemNo,
    answers: $setup.cache.answers,
    onChangePaper: _cache[2] || (_cache[2] = $event => $setup.finishExam(3)),
    onChangeItem: _cache[3] || (_cache[3] = no => {
      $setup.itemNo = no;
      $setup.setcache();
    })
  }, null, 8, ["examType", "paperInfo", "itemNo", "answers"])) : _createCommentVNode("", true), $setup.paperInfo.items && ($setup.step == 0 || $setup.step == 3 || $setup.step == 4) ? (_openBlock(), _createBlock(_component_SelfEvaluation, {
    key: 3,
    examInfo: $props.examInfo,
    paperInfo: $setup.paperInfo,
    step: $setup.step,
    article: $setup.cache.answers,
    onSelfOver: $setup.changeStep
  }, null, 8, ["examInfo", "paperInfo", "step", "article", "onSelfOver"])) : _createCommentVNode("", true)], 64);
}